/**
 * 아바타 URL 생성기 유틸리티
 * 
 * DiceBear API를 활용하여 다양한 스타일의 기본 아바타를 생성합니다.
 * 사용자의 이름이나 ID를 시드로 사용하여 일관된 아바타를 생성합니다.
 */ /**
 * 주어진 시드와 스타일에 기반한 아바타 URL을 생성합니다.
 * 
 * @param seed 아바타 시드 (일반적으로 사용자 이름 또는 ID)
 * @param style 아바타 스타일 (기본값: 'avataaars')
 * @returns 아바타 이미지 URL
 */ export function generateAvatarUrl(seed) {
    var style = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'avataaars';
    // 시드가 비어있거나 유효하지 않은 경우 기본 시드 사용
    var safeSeed = (seed === null || seed === void 0 ? void 0 : seed.trim()) ? seed : 'default';
    // 스타일별 특수 파라미터 설정
    var styleParams = getStyleParams(style);
    // DiceBear API URL 생성
    return "https://api.dicebear.com/7.x/".concat(style, "/svg?seed=").concat(encodeURIComponent(safeSeed)).concat(styleParams);
}
/**
 * 각 아바타 스타일에 맞는 추가 매개변수를 반환합니다.
 * 
 * @param style 아바타 스타일
 * @returns 스타일에 맞는 URL 매개변수 문자열
 */ function getStyleParams(style) {
    switch(style){
        case 'avataaars':
            // 다양한 색상과 스타일 옵션
            return '&backgroundColor=b6e3f4,c0aede,d1d4f9,ffd5dc,ffdfbf' + '&hairColor=0e0e0e,3eac2c,6a4e35,85c2c6,9e8239,cd7538,e8e1e1' + '&skinColor=f2d3b1,ecad80,bf9169,9e5622,763900' + '&clothesColor=2c5784,5199e4,25262a,929598,a7ffc4,ffdeb5,ffafb9,ffffb1,ff5c5c,e0e0e0';
        case 'bottts':
            // 로봇 스타일 옵션
            return '&radius=8&scale=80&backgroundType=solid,gradientLinear&backgroundColor=ffdfbf,b6e3f4,c0aede,d1d4f9,ffd5dc';
        case 'pixel-art':
            // 픽셀 아트 스타일 옵션
            return '&backgroundColor=b6e3f4,c0aede,d1d4f9,ffd5dc,ffdfbf&scale=8';
        case 'initials':
            // 이니셜 스타일 옵션
            return '&backgroundColor=b6e3f4,c0aede,d1d4f9,ffd5dc,ffdfbf&bold=true';
        case 'identicon':
            // 식별자 스타일 옵션
            return '&backgroundColor=b6e3f4,c0aede,d1d4f9,ffd5dc,ffdfbf&colorLevel=600';
        case 'thumbs':
            // 엄지 캐릭터 옵션
            return '&backgroundColor=b6e3f4,c0aede,d1d4f9,ffd5dc,ffdfbf&scale=80&shirtColor=77311d,ffffff,000000,3a4466';
        case 'lorelei':
            // 그림체 캐릭터 옵션
            return '&backgroundColor=b6e3f4,c0aede,d1d4f9,ffd5dc,ffdfbf&accessories=sunglasses';
        default:
            return '';
    }
}
